import { InlineStack, Text } from "@shopify/polaris";
import { format, formatDistanceToNow } from "date-fns";
import { lt, enUS } from "date-fns/locale";
import { useTranslation } from "react-i18next";

type Props = {
  createdAt: number | null | undefined;
};

export function AuditLogTime({ createdAt }: Props) {
  const { i18n } = useTranslation();

  if (createdAt == null) {
    return null;
  }
  const d = new Date(createdAt);
  if (Number.isNaN(d.getTime())) {
    return null;
  }

  const currentLanguage = (i18n as any)?.language || (i18n as any)?.resolvedLanguage || "en";
  const locale = currentLanguage === "lt" ? lt : enUS;

  const absolute = format(d, "yyyy-MM-dd HH:mm", { locale });
  const relative = formatDistanceToNow(d, { addSuffix: true, locale });
  
  return (
    <InlineStack gap="200" blockAlign="center" wrap>
      <Text as="span" variant="bodySm" fontWeight="semibold">
        {absolute}
      </Text>
      <Text as="span" variant="bodySm" tone="subdued">
        ({relative})
      </Text>
    </InlineStack>
  );
}
